// Keys ougt to be sorted alphabetically, case sensitive.
// To autosort: repeat CTRL+S until all keys are sorted
//  OR
// repeat command until sorted: npm run lint-fix

/* eslint sort-keys-fix/sort-keys-fix: error */
export default {
  accesslog: {
    accessedAt: 'Datum tijd',
    accessedBy: 'Geopend door',
    accessedResource: 'Gebruikte bron',
    ip: 'IP',
    parameters: 'Parameters'
  },
  ban: {
    bannedAtUtc: 'Verbannen op (UTC)',
    bannedUntilUtc: 'Verbannen tot (UTC)'
  },
  common: {
    active: 'Actief',
    add: 'Toevoegen',
    address: 'Adres',
    addressee: 'Geadresseerde',
    articleNumber: 'Artikelnummer',
    back: 'Terug',
    bankAccountBIC: 'BIC',
    bankName: 'Bank',
    barcodePrefix: 'Barcode voorloopnummer',
    barcodeType: 'Type barcode',
    bdo: 'BDO',
    billingAddress: 'Factuuradres',
    billingEmail: 'Factuur E-mailadres',
    block_notification_not_saved_warning: 'Notificatie instelling niet opgeslagen. Probeer het later opnieuw',
    browserNotSupported: 'Uw browser ondersteunt deze functionaliteit niet',
    businessRegisterNumber: 'KvK-nummer',
    cancel: 'Annuleren',
    city: 'Plaats',
    clearFilters: 'Verwijder alle filters',
    clientSales: 'Client sales GL',
    close: 'Sluiten',
    close_unsaved_warning: 'Uw wijzigingen zijn nog niet opgeslagen. Weet u zeker dat u dit scherm wilt sluiten?',
    code: 'Code',
    company: 'Bedrijf',
    companyAddress: 'Bezoekadres',
    companyEmail: 'E-mailadres',
    confirm: 'Bevestigen',
    continue: 'Doorgaan',
    copy: 'Kopiëren',
    copyToClipboard: 'Kopiëer naar klembord',
    copyToClipboardFail: 'Kopiëren naar klembord mislukt',
    copyToClipboardSuccess: 'Kopiëren naar klembord gelukt',
    country: 'Land',
    createReport: 'Maak overzicht',
    createdAt: 'Aangemaakt op',
    creditorNumber: 'Crediteurennummer',
    currency: 'Valuta',
    data_created: 'De gegevens zijn opgeslagen',
    data_save_error: 'De gegevens kunnen niet worden opgeslagen',
    data_updated: 'De wijzigingen zijn opgeslagen',
    date: 'Datum',
    debtorNumber: 'Debiteurennummer',
    decimals: 'Decimalen',
    defaultBottomFinishID: 'Standaard onderzoom',
    defaultBottomFinishMeasurementInCm: 'Standaardmaat onderzoom (cm)',
    defaultEmbraceFinishID: 'Standaard embrasse',
    defaultExtraFinishID: 'Standaard extra',
    defaultLiningBottomFinishID: 'Onderzoom voering',
    defaultLiningBottomFinishMeasurementInCm: 'Maat onderzoom voering (cm)',
    defaultSideFinishID: 'Standaard zijzoom',
    defaultSideFinishMeasurementInCm: 'Standaardmaat zijzoom (cm)',
    defaultTopFinishID: 'Standaard bovenafwerking',
    defaultTopFinishMeasurementInCm: 'Standaardmaat bovenafwerking (cm)',
    delete: 'Verwijderen',
    deletePlural: 'Verwijderen',
    delete_cancelled: 'Verwijderen geannuleerd',
    delete_completed: 'De gegevens zijn verwijderd',
    delete_record_summary_warning: 'Weet u zeker dat u <b>{summary}</b> wilt verwijderen?',
    delete_record_warning: 'Weet u zeker dat u dit wilt verwijderen?',
    department: 'Afdeling',
    description: 'Beschrijving',
    domain: 'Domein',
    domains: 'Domeinen',
    dontSave: 'Niet opslaan',
    dontSend: 'Niet verzenden',
    dont_show_again_warning: 'Niet meer tonen',
    downloadExcel: 'Download Excel',
    downloadPDF: 'Download PDF',
    draft: 'Concept',
    ean: 'EAN-13',
    edit: 'Bewerken',
    email: 'E-mailadres',
    emptyString: ' ',
    endDate: 'Einddatum',
    error: 'Fout',
    exactInstance: 'Exact',
    excludedFinishes: 'Niet mogelijke afwerkingen',
    export: 'Export',
    fabric: 'Stof',
    fabricProduct: 'Stofsoort',
    fabricType: 'Stofsoort',
    fabricWidth: 'Stofbreedte',
    fabrics: 'Stoffen',
    fax: 'Fax',
    fillInANumber: 'Vul een getal in',
    finish: 'Afwerking',
    finishType: 'Afwerkingssoort',
    firstName: 'Voornaam',
    fixedPhone: 'Vaste telefoon',
    from: 'van',
    gender: 'Geslacht',
    general: 'Algemeen',
    glAccountNumber: 'Grootboeknummer',
    glAccountNumbers: 'Grootboeknummers',
    globalLocationNumber: 'GLN',
    houseNumber: 'Huisnummer',
    iban: 'IBAN',
    id: 'ID',
    inactive: 'Inactief',
    initials: 'Initialen',
    intercompanySales: 'IC sales GLs',
    invoiceAddress: 'Factuuradres',
    ipAddress: 'IP-adres',
    jobFunction: 'Functie',
    key: 'Key',
    label: 'Label',
    lastName: 'Achternaam',
    leave_mail_warning: 'U verlaat deze pagina. Wilt u eerst deze mail verzenden?',
    leave_unsaved_warning: 'U verlaat deze pagina. Wilt u de wijzigingen opslaan?',
    lineNumber: 'Regelnummer',
    lining: 'Voering',
    loading: 'Laden ...',
    mailingAddress: 'Postadres',
    measurement: 'Afmeting',
    measurements: 'Afmetingen',
    meter: 'meter',
    mobilePhone: 'Mobiele telefoon',
    modifiedAt: 'Gewijzigd op',
    name: 'Naam',
    no: 'Nee',
    notApplicable: 'Niet van toepassing',
    notApplicableAbbr: 'n.v.t.',
    number: 'Nummer',
    off: 'Uit',
    ok: 'OK',
    on: 'Aan',
    order: 'Order',
    orderLine: 'Orderregel',
    order_processed: 'Order succesvol verwerkt',
    orders: 'Orders',
    otherPrintClients: 'Overig',
    page: 'Pagina',
    palletNumber: 'Palletnummer',
    parcelType: 'Verpakking',
    password: 'Wachtwoord',
    phone: 'Telefoon',
    plannedWorkshopPrintClient: 'Atelier als gepland',
    postalCode: 'Postcode',
    prefill: 'Voorinvullen',
    prefix: 'Tussenvoegsel',
    price: 'Prijs',
    priceListItem: 'Prijslijstitem',
    printers: 'Printers',
    priority: 'Prioriteit',
    product: 'Artikel',
    productGroup: 'Productgroep',
    productType: 'Artikelsoort',
    publish: 'Publiceren',
    readMore: 'Lees meer ...',
    remark: 'Opmerking',
    remarks: 'Opmerkingen',
    required: 'Verplicht',
    returnOrder: 'Retourorder',
    save: 'Opslaan',
    saveClose: 'Opslaan & sluiten',
    saveNext: 'Opslaan & volgende',
    search: 'Zoek',
    selectPrinter: 'Selecteer bestemming voor printen',
    selectPrinterConfirm: 'Selecteer',
    send: 'Verzenden',
    series: 'Series',
    service: 'Service',
    shipmentList: 'Verzendlijst',
    standard: 'Standaard',
    startDate: 'Begindatum',
    status: 'Status',
    stay: 'Blijf op pagina',
    stockLocation: 'Voorraadlocatie',
    stockLocations: 'Voorraadlocaties',
    stockUnit: 'Verpakkingseenheid',
    store: 'Vestiging',
    stores: 'Vestigingen',
    streetName: 'Straat',
    streetNumber: 'Huisnummer',
    success: 'Succes',
    supplier: 'Leverancier',
    switchOff: 'Uit',
    switchOn: 'Aan',
    tabDetails: 'Details',
    tabGeneral: 'Algemeen',
    taskstatus: 'Taakstatus',
    ticketBarcode: 'Bonbarcode',
    ticketBarcodeNotFound: 'Bonbarcode niet gevonden',
    till: 'tot',
    title: 'Titel',
    to: 'Naar',
    total: 'Totaal',
    transport: 'Transport',
    type: 'Type',
    unit: 'Eenheid',
    username: 'Gebruikersnaam',
    value: 'Value',
    vatNumber: 'BTW-nummer',
    warning: 'Waarschuwing',
    week: 'Week',
    weeks: 'Weken',
    workshop: 'Atelier',
    workshopPrintClients: 'Ateliers',
    workshops: 'Ateliers',
    yarn: 'Garen',
    year: 'Jaar',
    yes: 'Ja'
  },
  company: {
    administrationNumber: 'Administratienummer',
    clientSalesJournalCode: 'Verkoopdagboek klantfactuur',
    exact: 'Exact',
    exactServerName: 'Servernaam',
    fiscalUnit: 'Fiscale eenheid',
    intercompanySalesJournalCode: 'Verkoopdagboek intercompany factuur',
    intrastatReporting: 'Intrastat-rapportage',
    logo: 'Logo',
    purchaseJournalCode: 'Inkoopdagboek nummer',
    purchaseJournalType: 'Inkoopdagboek type',
    remarkInvoice: 'Opmerking factuur',
    salesJournalType: 'Verkoopdagboek type'
  },
  componentList: {
    amountReturn: 'Retour',
    extras: 'Extras',
    lined: 'Gevoerd',
    metersAmount: 'Aantal meters',
    panelsAmount: 'Aantal banen',
    piecesAmount: 'Aantal stuks',
    product: 'Component',
    productType: 'Productsoort',
    romanBlindsAmount: 'Aantal vouwgordijnen',
    total: 'Totaal',
    totals: 'Totalen',
    unlined: 'Ongevoerd',
    weeks: 'Weken'
  },
  configuration: {
    code: 'Code',
    fromDate: 'Geldig vanaf',
    value: 'Waarde'
  },
  country: {
    eu: 'Europese Unie'
  },
  currency: {
    isoCode: 'ISO code',
    symbol: 'Symbool'
  },
  domain: {
    all: 'Mijn domeinen',
    allowDuplicateStoreCodes: 'Dubbele vestigingsnummers',
    apiKey: 'API key',
    autoProcessFabricOrders: 'Stoforders automatisch opboeken',
    barcodePrefix: 'Barcode prefix',
    calculateOrderLinesForInteriorDecorator: 'Bereken orderregel details woninginrichter',
    chooseDomain: 'Kies een domein',
    company: 'Bedrijf',
    copyDataFromDomain: 'Data kopiëren van',
    createFabrics: 'Stoffen aanmaken',
    culture: 'Cultuur',
    cultures: 'Culturen',
    defaultDeliverAtHomeYN: 'Standaard thuisbezorgen',
    deliveryPrice: 'Bezorgprijs',
    deliveryPrices: 'Bezorgprijzen',
    distributionCenter: 'Distributiecentrum',
    domainCode: 'Code domein',
    domainDescription: 'Omschrijving domein',
    export: 'Facturen exporteren via',
    familyOrderPacking: 'Family order packing',
    houseNumberValidationDisabled: 'Validatie huisnummer uitgeschakeld',
    invalidFinishCombinations: 'Niet-toegestane afwerkingscombinaties',
    invoiceName: 'Naam op factuur',
    invoicePer: 'Factureren per',
    keepCalculatedValuesOnReturnOrder: 'Berekeningen behouden bij retour',
    lastStockWorkshop: 'Ontvangend atelier uitlopende voorraad',
    nameOnTicket: 'Naam op bon',
    noData: 'Geen domeinen bekend',
    orderNumberPrefix: 'Ordernummer prefix',
    paymentDiscountPercentage: 'Betalingskorting (%)',
    paymentTermDays: 'Betalingstermijn (dagen)',
    priceDescription: 'Gekoppelde prijs',
    productGroup: 'Instellingen productgroep',
    productGroupFinishApplicable: 'Beschikbaar voor dit domein',
    productGroupFinishes: 'Domeinspecifieke afwerkingen',
    productGroupPrices: 'Prijzen',
    productGroupSettings: '{domainName} - Instellingen voor productgroep {productGroup}',
    quarterPanels: 'Kwartbanen',
    rfidEnabledYN: 'RFID',
    rfidPrefix: 'RFID prefix',
    shareHalfPanels: 'Halve banen delen',
    showOrdersInvoicePer: 'Showbanen factureren per',
    standardDeliveryPeriod: 'Standaard bezorgtermijn in dagen',
    storeAttributes: 'Kenmerken vestiging',
    storeTypes: 'Vestigingstypes',
    stores: 'Vestigingen',
    stripCorrection: 'Stripcorrectie (banen)',
    tabContactPersons: 'Contactpersonen',
    tabGeneral: 'Algemeen',
    tabProducts: 'Artikelen',
    tabSettings: 'Instellingen',
    ticketLanguage: 'Taal op bon',
    transportOrderMultipleWorkshops: 'Meerdere ateliers op verzendlijst'
  },
  draftTool: {
    black: 'Zwart',
    chrome: 'Chroom',
    electric: 'Elektrisch',
    fixtureGrommets: 'Ringen',
    fixturePole: 'Roede met ring',
    fixtureRail: 'Rail',
    fixtureTabTop: 'Lussen',
    fixtureTunnelAtTop: 'Roede met tunnel',
    fixtureTunnelAtTopAndBottom: 'Roede met tunnel op span',
    fixtureWaveCurtain: 'Wavegordijn',
    hemDouble: 'Dubbel',
    hemNone: 'Geen',
    hemSingle: 'Enkel',
    left: 'Links',
    manual: 'Handmatig',
    piecesBoth: 'Twee delen',
    piecesLeft: 'Deel links',
    piecesRight: 'Deel rechts',
    pleatDouble: 'Dubbele plooi',
    pleatDoubleReturn: 'Dubbele en retourplooi',
    pleatFlat: 'Platte plooi',
    pleatSingle: 'Enkele plooi',
    pleatSingleReturn: 'Enkele en retourplooi',
    pleatTriple: 'Driedubbele plooi',
    pleated: 'Geplooid',
    pleatingTape: 'Plooiband',
    productGroupCurtain: 'Overgordijn baanstof',
    productGroupLaces: 'Vitrage kamerhoog',
    productGroupRomanBlind: 'Vouwgordijn',
    productGroupRoomHighCurtain: 'Overgordijn kamerhoog',
    productGroupTieBack: 'Embrasse',
    right: 'Rechts',
    setFromBottom: 'Set onder',
    setFromTop: 'Set boven',
    setNone: 'Geen set',
    tape: 'Bandje',
    tbd: 'n.t.b.',
    tieBackBanana: 'Banaan',
    tieBackNone: 'Geen',
    tieBackStraight: 'Recht',
    tight: 'Strak',
    tunnelBack: 'Tunnel achter',
    tunnelFront: 'Tunnel voor',
    white: 'Wit'
  },
  error: {
    general_request: 'Er is iets fout gegaan. Probeer het later opnieuw.',
    oneOrMoreInputs: 'De gegevens kunnen niet worden opgeslagen want het formulier bevat fouten.',
    save: 'Er is iets fout gegaan. Probeer het later opnieuw.'
  },
  errorLog: {
    description:
      'Now the management system are basically the form of the spa, it enhances the user experience, but it also increases the possibility of page problems, a small negligence may lead to the entire page deadlock. Fortunately Vue provides a way to catch handling exceptions, where you can handle errors or report exceptions.',
    documentation: 'Document introduction',
    tips: 'Please click the bug icon in the upper right corner'
  },
  errorPages: {
    backToHome: 'Terug naar thuispagina',
    headline401: 'U heeft geen toegang tot deze pagina',
    headline403: 'U heeft geen toegang tot deze pagina',
    headline404: 'Pagina niet gevonden',
    message401: 'Indien u het hier niet mee eens bent, neem dan contact op met uw beheerder.',
    message403: 'Indien u het hier niet mee eens bent, neem dan contact op met uw beheerder.',
    message404: 'Controleer of de ingevoerde URL correct is.',
    return: 'Terug',
    title401: 'Oops',
    title403: 'Toegang geweigerd',
    title404: 'Sorry'
  },
  eventlog: {
    exception: 'Exception',
    level: 'Level',
    logger: 'Logger',
    message: 'Message',
    occurredAt: 'Datum tijd',
    thread: 'Thread'
  },
  exactInstance: {
    serverName: 'Servernaam',
    serviceUrl: 'Service URL'
  },
  fabric: {
    actualWidth: 'Werkelijke breedte (cm)',
    availableStock: 'Vrije voorraad',
    blackout: 'Verduisterend',
    canBeLined: 'Kan worden gevoerd',
    canBeUsedAsLiningForRomanBlindsYN: 'Geschikt voor voering vouwgordijnen',
    canBeUsedAsLiningYN: 'Geschikt voor voering',
    canBeUsedForRomanBlinds: 'Geschikt voor vouwgordijnen',
    collections: 'Stofboeken',
    consumerPrices: 'Consumentprijzen',
    containsWeightCord: 'Heeft verzwaringskoord',
    cordProduct: 'Vouwgordijn koord',
    createdAt: 'Aangemaakt op',
    cuttingWastePercentage: 'Snijverlies (%)',
    description: 'Stofnaam',
    discontinuationDate: 'Datum vervallen',
    domainProductCode: 'Artikelnummer',
    excludedWorkshops: 'Uitgesloten ateliers',
    fabricStatusOption: 'Status',
    fabricWidth: 'Stofbreedte (cm)',
    flawInWeavingPercentage: 'Weeffout onderverdeling (%)',
    handlock: 'Handlock',
    hasPattern: 'Patroonstof',
    ironYN: 'Strijken',
    leftOverPercentage: 'Reststuk onderverdeling (%)',
    liningCordProduct: 'Vouwgordijn koord bij stof als voering',
    lockSeamWidth: 'Breedte locknaad (cm)',
    nap: 'Vleug',
    noCordProductID: 'Onbekend',
    nonDiverseLinings: 'Standaard voering',
    partsPerHanger: 'Maximum aantal delen per hanger',
    pattern: 'Patroon',
    patternHeight: 'Patroonhoogte (mm)',
    posCode: 'POS code',
    preferredWorkshop: 'Voorkeursatelier',
    prices: 'Prijzen',
    productType: 'Stofsoort',
    purchasePrice: 'Inkoopprijs',
    romanBlindCanBeLinedYN: 'Vouwgordijn kan gevoerd worden',
    romanBlindCode: 'Vouwgordijn code',
    romanBlindRibTypeOption: 'Baleinen',
    sellingPrice: 'Verkoopprijs',
    solid: 'Effen',
    sourceLinkDomainProductGroup: 'Domeinspecifiek',
    sourceProductGroup: 'Productgroep',
    staggeredPatternYN: 'Verspringend patroon',
    stockCorrections: 'Mutaties',
    stocks: 'Beschikbare voorraad',
    tabDetails: 'Details',
    tabGeneral: 'Algemeen',
    takeOverFromProductGroupToolTip: 'van {productGroupName} ({sourceName})',
    takeOverFromSettingsToolTip: 'van instellingen ({settingsName})',
    washingInstructionProduct: 'Wasinstructies',
    weightCordProduct: 'Verzwaringskoord',
    weightPerM2InG: 'Gewicht per m2 (g)',
    width: 'Breedte (cm)',
    yarn: 'Garen'
  },
  fabricOrder: {
    actualDeliveryAt: 'Werkelijke leverdatum',
    createdAt: 'Aanmaakdatum',
    deliveredQuantity: 'Geleverd (m)',
    domainName: 'Domein',
    estimatedDeliveryAt: 'Verwachte leverdatum',
    estimatedDepartureAt: 'Verwachte vertrekdatum',
    externallyModifiedAt: 'Gewijzigd op',
    fabricOrderStatusOption: 'Status',
    feedbackError: 'Gefaald',
    feedbackOK: 'OK',
    feedbackSuccessYN: 'Terugmelding',
    feedbackUndefined: '-',
    orderLines: 'Orderregels',
    orderNumber: 'Ordernummer',
    orderedQuantity: 'Besteld (m)',
    plannedDeliveryAt: 'Geplande leverdatum',
    stockLocationName: 'Voorraadlocatie',
    supplierCode: 'Leveranciersnummer',
    supplierName: 'Leverancier',
    tabGeneral: 'Algemeen',
    totalDeliveredQuantity: 'Totaal geleverd (m)',
    totalQuantityDeliveredInMeters: 'Totaal geleverd m',
    totalQuantityOrderedInMeters: 'Besteld m'
  },
  fabricStockReport: {
    availableStock: 'Vrij',
    blockedStock: 'Geblokkeerd',
    excelFileName: 'Voorraadoverzicht',
    excelWorksheetName: 'Voorraad',
    includeAvailableAmount: 'Beschikbare voorraad',
    includeBlockedAmount: 'Geblokkeerde voorraad',
    includePositionCode: 'Locatiecode',
    includeReservedAmount: 'Onderhanden werk',
    positionCode: 'Locatiecode',
    reservedStock: 'OHW',
    soldStock: 'Verkocht',
    stockLocations: 'Voorraadlocaties',
    stockReportData: 'Voorraadoverzicht',
    tabGeneral: 'Selectie gegevens',
    totalStock: 'Totaal'
  },
  fileUpload: {
    dragAndDropHtml: 'Zet hier een bestand neer of<br><em>klik hier om een bestand te selecteren</em>',
    uploadTip: 'Upload een bestand tot 2 MB'
  },
  finish: {
    applyPleatMachineCorrectionYN: 'Machine en laser correctie toepassen',
    canBeExcludedDueToFabricYN: 'Stofbeperkingen van toepassing',
    canBeExcludedDueToWorkshopYN: 'Atelierbeperkingen van toepassing',
    defaultProduct: 'Standaard artikel',
    extraFabricHeightFormula: 'Formule extra stofhoogte',
    extraFabricWidthFormula: 'Formule extra stofbreedte',
    fabricWidthFactor: 'Stofbreedte factor',
    finishMeasurementFabricFactor: 'Factor op de afwerkingsmaat',
    headingHeight: 'Hoofdhoogte (cm)',
    hideQuantityOnTicket: 'Verberg aantal op bon',
    maximumFabricWidthFactor: 'Bovengrens stofbreedte factor',
    minimumFabricWidthFactor: 'Ondergrens stofbreedte factor',
    parityOption: 'Pariteit',
    quantityFormula: 'Formule voor aantal',
    roundOption: 'Afronding',
    seperateSeriesYN: 'Aparte serie'
  },
  finishType: {
    calculationMethod: 'Rekenwijze',
    extraFabricHeightApplicable: 'Extra stofhoogte van toepassing',
    extraFabricWidthApplicable: 'Extra stofbreedte van toepassing',
    fabricWidthFactorRequired: 'Stofbreedte factor vereist',
    finishes: 'Afwerkingen',
    measurementRequired: 'Afmeting vereist',
    requiredProductType: 'Benodigde artikelsoort'
  },
  forgotPassword: {
    description:
      'U kunt uw wachtwoord opnieuw instellen. Vul het onderstaande formulier in om de instructies per email te ontvangen.',
    done: 'Er is een email verstuurd naar {email}. Volg de instructies die hierin zijn vermeld.',
    submit: 'Verstuur email',
    title: 'Wachtwoord vergeten'
  },
  hemaPendingProject: {
    customerDebtorCode: 'Customer debtor code',
    customerDeliveryCode: 'Customer delivery code',
    customerName: 'Customer name',
    prjDate: 'Project date',
    prjNumber: 'Project number',
    sentDate: 'Sent date'
  },
  home: {
    orderLineStatusSummary: 'STATUSOVERZICHT',
    quickSearch: 'SNEL ZOEKEN',

    welcomeVisitor: 'Welkom bezoeker'
  },
  interiorDecorator: {
    assemblyHeight: 'Montagehoogte (cm)',
    attachLeadCord: 'Loodkoord aanzetten',
    bananaTieback: 'Banaan embrasse',
    band: 'Band (cm)',
    bottomHem: 'Onderzoom',
    bottomHemSize: 'Onderzoom (cm)',
    brackets: 'Haakjes',
    chain: 'Ketting',
    cutSize: 'Knipmaat (cm)',
    cutSizeLeft: 'Knipmaat links (cm)',
    cutSizeRight: 'Knipmaat rechts (cm)',
    duplicate: 'Dupliceer regel',
    fabricTotal: 'Totaalstof (cm)',
    fabricWidth: 'Stofbreedte (cm)',
    finish: 'Afwerking',
    fixture: 'Ophangmethode',
    grommets: 'Kleur & diameter',
    headingHeight: 'Hoofdje (cm)',
    height: 'Hoogte (cm)',
    numberOfPanels: 'Banen',
    operatingSide: 'Bedieningskant',
    operatingType: 'Bediening',
    panelsLeft: 'Banen links',
    panelsRight: 'Banen rechts',
    pieces: 'Aantal delen',
    pleat: 'Plooi',
    pleatingTapeSize: 'Afmeting plooiband (cm)',
    productType: 'Productsoort',
    railLength: 'Raillengte (cm)',
    requiredFabric: 'Benodigde stof (cm)',
    ribs: 'Baleinen',
    romanBlindSubtype: 'Productsubgroep',
    set: 'Set',
    straightTieback: 'Rechte embrasse',
    system: 'Systeem',
    tieBack: 'Embrasse',
    tunnelPercentage: 'Stof op roede',
    tunnelSize: 'Afmeting tunnel (cm)',
    type: 'Soort',
    waveSize: 'Afstand haakjes (cm)',
    width: 'Breedte (cm)',
    widthLeft: 'Breedte links (cm)',
    widthRight: 'Breedte rechts (cm)'
  },
  invalidFinishCombination: {
    finish1: 'Afwerking 1',
    finish2: 'Afwerking 2'
  },
  inventory: {
    instruction:
      'Kies een voorraadlocatie en upload een CSV bestand. Het bestand dient de volgende drie kolommen te hebben: Domein;Artikelnummer;Vrij.',
    inventoryUpdated: 'Voorraadstanden succesvol bijgewerkt',
    updateInventory: 'Voorraadstanden inlezen'
  },
  invoice: {
    clientName: 'Klant',
    details: 'Overzicht orders',
    exportAccountingAt: 'Verzonden finance',
    exportClientAt: 'Verzonden klant',
    externalInvoice: 'Externe factuur',
    internalInvoice: 'Interne factuur',
    invoiceDate: 'Factuurdatum',
    invoiceNumber: 'Factuurnr.',
    invoiceType: 'Factuurtype',
    invoicedInternallyYN: 'IC fact.',
    invoicesPrinted: 'De PDF(s) zijn aangemaakt',
    month: 'Maand',
    numberOfOrders: 'Bonnen',
    print: 'Printen',
    purchaseInvoiceExportedOn: 'IC inkoopfactuur naar Exact',
    salesInvoiceExportedOn: 'IC verkoopfactuur naar Exact',
    selectedInvoices: 'Facturen',
    storeCode: 'Vestiging',
    summary: 'Overzicht totalen',
    totalAmountExcludingVAT: 'Totaal excl. BTW',
    totalAmountIncludingVAT: 'Totaal incl. BTW',
    year: 'Jaar'
  },
  invoiceSummary: {
    create: 'Maak factuuroverzicht',
    from: 'Van',
    to: 't/m'
  },
  kwantum: {
    errorMessage: 'Error message',
    failedYN: 'Failed',
    m1_OrderNumberBuyer: 'M1 Order number buyer',
    m1_QueuedAt: 'M1 Processed on',
    m2_PolygonNumber: 'M2 Polygon number',
    m2_ProjectID: 'M2 Project ID',
    m2_PurchaseNumber: 'M2 Purchase number',
    m2_QueuedAt: 'M2 Processed on'
  },
  language: {
    code: 'ISO 639-1 Code'
  },
  linkPriceListItem: {
    blackoutYN: 'Verduisterd',
    extraCostYN: 'Extra kosten',
    finishesDescription: 'Afwerkingen',
    priceListItem: 'Prijslijstitem',
    priceListItemDescription: 'Prijslijstitembeschrijving',
    selectedFinishes: 'Afwerkingen'
  },
  login: {
    code: 'Gebruikersnaam',
    forbidden: 'Gebruiker/IP combinatie is geblokkeerd.',
    logIn: 'Inloggen',
    password: 'Wachtwoord',
    title: 'Inloggen',
    unauthorised: 'Deze inloggegevens zijn onjuist.'
  },
  mail: {
    bcc: 'Bcc',
    body: 'Bericht',
    cc: 'Cc',
    error: 'Er is een probleem opgetreden. Uw email is niet verstuurd.',
    from: 'Van',
    subject: 'Onderwerp',
    success: 'Uw email is succesvol verzonden',
    to: 'Aan'
  },
  navbar: {
    dashboard: 'Dashboard',
    language: 'Taal',
    logOut: 'Uitloggen',
    screenfull: 'Screenfull',
    size: 'Global Size',
    theme: 'Theme'
  },
  newPassword: {
    description: 'U kunt nu uw wachtwoord permanent wijzigen.',
    done: 'Uw wachtwoord is gewijzigd.',
    invalidToken: 'Deze link is verlopen.',
    submit: 'Wijzig wachtwoord',
    title: 'Nieuw wachtwoord'
  },
  order: {
    clientName: 'Klant',
    consumerAddress: 'Adres consument',
    consumerDetails: 'Klantgegevens',
    consumerName: 'Naam consument',
    createSamples: 'Samples aanmaken',
    createdAt: 'Invoerdatum',
    finish: 'Afronden',
    internalRemarks: 'Opmerking intern',
    orderNumber: 'Ordernummer',
    orderStatus: 'Status',
    orderedAt: 'Besteldatum',
    source: 'Bron',
    storeName: 'Vestiging',
    type: 'Bon soort',
    validate: 'Valideren'
  },
  orderDraft: {
    addLine: 'Nieuwe order toevoegen',
    bracketsExcluded: 'Excl. haakjes',
    bracketsIncluded: 'Incl. haakjes',
    calculating: 'Order wordt (her)berekend',
    consumerData: 'Klantgegevens',
    draftSaved: 'Concept opgeslagen',
    leaveWithoutSaving: 'De pagina is niet opgeslagen. Doorgaan?',
    orderLineCount: 'Aantal regels',
    placeOrder: 'Bestellen',
    saveDraft: 'Opslaan',
    send: 'Verzenden',
    specials: 'Specials'
  },
  orderDraftValidation: {
    bottomHem: 'Onderzoom is vereist.',
    bottomHemSize: 'Onderzoom (cm) is vereist.',
    colorAndDiameter: 'Kleur & diameter zijn vereist.',
    customerReference: 'Bestelnummer ontbreekt',
    fabric: 'Stof is vereist.',
    fabricWidth: 'De benodigde stofhoogte is meer dan de stofbreedte.',
    fixture: 'Ophangmethode is vereist.',
    height: 'Hoogte is vereist.',
    hooks: 'Haakjes is vereist.',
    hooksDistance: 'Afstand haakjes is vereist.',
    operatingSide: 'Bedieningskant is vereist.',
    pleat: 'Plooi is vereist.',
    pleatFactorPanel: 'Plooifactor valt buiten toegestane waardes, pas banen aan.',
    pleatFactorRoomHigh: 'Plooifactor valt buiten toegestane waardes, pas knipmaat aan.',
    productGroup: 'Producttype is vereist.',
    railLength: 'Raillengte is vereist.',
    romanBlindFabricWidth: 'Het vouwgordijn is te hoog t.o.v. de stofbreedte.',
    tieBackType: 'Soort is vereist.',
    tunnelPercentage: 'Stof op roede is vereist.',
    tunnelSize: 'Afmeting tunnel is vereist',
    width: 'Breedte is vereist.'
  },
  orderLine: {
    actualDeliveryDate: 'Uitleverdatum',
    alignPatternTopYN: 'B.O.P.',
    alignPatternYN: 'Op patroon',
    amount: 'Aantal',
    assemblyHeight: 'Montagehoogte (cm)',
    bandMeasurementInCm: 'Band (cm)',
    bottomFinish: 'Onderafwerking',
    bottomSeam: 'Onderzoom',
    chainProduct: 'Ketting',
    chainSystem: 'Kettingsysteem',
    confirmPrint: 'Weet u zeker dat u de bon wilt printen?',
    consumerName: 'Klantnaam',
    cordProduct: 'Koord',
    createNewPrice: 'Maak een prijs op maat',
    createReturnOrder: 'Retourorder maken',
    customerReference: 'Bestelnummer',
    customerRemarks: 'Opmerkingen klant',
    cutSize: 'Knipmaat (cm)',
    cutSizeLeft: 'Knipmaat links (cm)',
    cutSizeRight: 'Knipmaat rechts (cm)',
    deliver: 'Thuisbezorgen',
    delivery: 'Levering',
    deliveryDate: 'Uitleverdatum',
    details: 'Details',
    discount: 'Korting',
    discountPercentage: 'Kortingspercentage',
    embrace: 'Embrasse',
    embraceForOrderNumber: 'Embrasse voor',
    embraceFromFinish: 'Soort',
    embraceFromOrderLine: 'Embrasse',
    embraceFromOrderNumber: 'Embrasse van',
    embraceHeight: 'Hoogte (cm)',
    embraceLengthLeft: 'Lengte links (cm)',
    embraceLengthRight: 'Lengte rechts (cm)',
    equal: 'Gelijk',
    equalParts: 'Gelijke delen',
    estimatedDeliveryDate: 'Verwachte leverdatum',
    exceedance: 'Overschrijding',
    extras: "Extra's",
    fabricName: 'Stofnaam',
    fabricStatus: 'Stofstatus',
    fabricWidth: 'Stofbreedte (cm)',
    familyOrder: 'Familieorder',
    familyOrderLines: 'Orders',
    finishedWidth: 'Klare breedte (cm)',
    fixtureFinish: 'Bevestiging',
    fromStatus: 'Van status',
    generalFinish: 'Algemene afwerking',
    groupReference: 'Groep referentie',
    groupTotal: 'Groep totaal',
    halfPanelFrom: 'Halve baan van',
    halfPanelTo: 'Halve baan naar',
    headingHeight: 'Hoofdje (cm)',
    height: 'Klare hoogte (cm)',
    highestInSet: 'Hoogste in set (cm)',
    length: 'Lengte (cm)',
    liningFabricProduct: 'Stof voor voering',
    measurement: 'Maat',
    metersAmountLeft: 'Meters links',
    metersAmountRight: 'Meters rechts',
    numberOfCords: 'Aantal koorden',
    numberOfHangers: 'Aantal hangers',
    numberOfPanels: 'Aantal banen',
    numberOfPanelsLeft: 'Banen links',
    numberOfPanelsRight: 'Banen rechts',
    numberOfParcels: 'Aantal hangers / colli',
    numberOfRibs: 'Aantal baleinen',
    numberOfSupports: 'Aantal montagesteunen',
    operationSide: 'Bediening',
    orderDate: 'Besteldatum',
    orderLinePriceType: 'Prijssoort',
    orderLineStatus: 'Status',
    orderLineStatusChangedAt: 'Status gewijzigd op',
    orderLineSubstatus: 'Substatus',
    orderLinesCancelledLastMonth: 'Orders geannuleerd sinds afgelopen maand',
    panelCustomerInfo: 'Klantinfo',
    panelFabricInfo: 'Stofinfo',
    panelFinish: 'Afwerking',
    panelGeneral: 'Algemeen',
    panelLiningFabricInfo: 'Voeringinfo',
    panelStatus: 'Status',
    panelsForCreation: 'Maakbanen',
    parts: 'Delen',
    patternHeight: 'Patroonhoogte (mm)',
    pickUp: 'Afhalen',
    pickUpStore: 'Afhaalvestiging',
    pleatFactor: 'Plooifactor',
    priceRestricted: 'Prijs kan niet aangepast worden omdat order al gefactureerd is.',
    prices: 'Prijzen',
    printProductionTicket: 'Print orderbon',
    printStatusOption: 'Printstatus',
    printStatusOptionFailed: 'Mislukt',
    printStatusOptionPrinted: 'Afgedrukt',
    printStatusOptionQueued: 'In wachtrij',
    product: 'Product',
    productGroup: 'Productsoort',
    productionTicketPrinted: 'De orderbon is verstuurd naar de printer',
    quantity: 'Aantal',
    railLength: 'Raillengte (cm)',
    remarksOnTicket: 'Opmerkingen op bon',
    ribsEqual: 'Baleinen gelijk',
    ribsSide: 'Baleinpositie',
    ribsType: 'Baleinen',
    ringProduct: 'Ring',
    room: 'Ruimte',
    sample: 'Staal',
    selectShipmentListDate:
      'Selecteer een datum voor een overzicht van bonnummers met de status verzenden op die datum',
    seriesNumber: 'Serienummer',
    shareHalfPanelWith: 'Baan delen met',
    shareHangerWith: 'Hanger delen met',
    sharesHalfPanel: 'Deelt halve baan met deze order',
    sharesHanger: 'Deelt hanger met deze order',
    shipmentListDate: 'Lijstdatum',
    show: 'Show',
    sideFinish: 'Zijzoom',
    specials: 'Specials',
    standardOrder: 'Standaard',
    status: 'Status',
    storeName: 'Vestigingsnaam',
    systemRemarks: 'Opmerkingen systeem',
    tabGeneral: 'Algemeen',
    tabHistory: 'Historie',
    tabPrices: 'Prijs',
    takeLeftoverFabric: 'Restant meenemen',
    ticketNumber: 'Bonnummer',
    ticketType: 'Bonsoort',
    toShipmentList: 'Naar verzendlijst',
    toStatus: 'Naar status',
    topFinish: 'Bovenafwerking',
    topFinishHeight: 'Hoogte bovenafwerking (cm)',
    totalAmount: 'Totaal',
    totalFabricInCm: 'Totaal stof (cm)',
    transportEAN: 'Transportnummer',
    transportStatus: 'Transportstatus',
    transportStatusChangedAt: 'Datum',
    unequal: 'Ongelijk',
    unequalParts: 'Ongelijke delen',
    urgent: 'Spoed',
    useExistingPrice: 'Gebruik een bestaande prijs',
    validationMessage: 'Reden uitval',
    waveSize: 'Wave lengte (cm)',
    weights: 'Loodjes',
    width: 'Breedte (cm)',
    widthLeft: 'Breedte links (cm)',
    widthRight: 'Breedte rechts (cm)',
    workshop: 'Atelier'
  },
  orderLineStatus: {
    cancellationAllowed: 'Annuleren',
    changable: 'Wijzigen',
    feedBack: 'Terugkoppelen klant',
    orderLineStatus: 'Hoofdstatus',
    orderLineSubstatus: 'Substatus',
    removeFromSeries: 'Verwijderen uit serie',
    scanParameter: 'Scan parameter',
    settable: 'Toekennen',
    substatusOrder: 'Volgorde',
    substatusOrderReserved: 'Dit nummer is gereserveerd'
  },
  orderLineStatusSummary: {
    fri: 'vr',
    mon: 'ma',
    sat: 'za',
    sun: 'zo',
    thu: 'do',
    total: 'Totaal',
    tue: 'di',
    wed: 'wo'
  },
  orderPick: {
    addFabric: 'Stof toevoegen',
    comments: 'comments',
    location: 'location',
    neededMeters: 'needed meters',
    pickListID: 'Lijstnummer',
    picked: 'Picked',
    pickedMeters: 'picked meters',
    pickedNumberOfRolls: 'picked no. of rolls',
    prefill: 'Pick needed m',
    processPickedItems: 'Opslaan',
    productCode: 'art. no',
    productDescription: 'fabric name',
    selectAPickList: 'Voer lijstnummer in',
    seriesNumbers: 'Serienummers',
    widthInCm: 'width',
    yarnNumber: 'yarn no'
  },
  parcelType: {
    alternativeParcelType: 'Alternatieve verpakkingseenheid',
    cuttingPackagesAndRoles: 'pakketten en rollen',
    hangers: 'hangers',
    maximumLengthInM: 'Maximum lengte (m)',
    maximumQuantity: 'Maximum aantal',
    maximumWeightInKg: 'Maximum gewicht (kg)',
    parcelTypeOption: 'Type verpakkingseenheid',
    romanBlindBoxes: 'dozen'
  },
  penalty: {
    handedOutAtUtc: 'Uitgedeeld op (UTC)',
    penaltyPoints: 'Strafpunten',
    penaltyType: 'Type'
  },
  permission: {
    AccessLog: 'Access log',
    AppSetting: 'Appsettings',
    Ban: 'Bans',
    Client: 'Klanten',
    ClientSalesReport: 'Omzetlijst',
    Collection: 'Stofboeken',
    Company: 'Bedrijven',
    Configuration: 'Instellingen',
    Country: 'Landen',
    Culture: 'Cultures',
    Currency: 'Valuta',
    DeliveryReport: 'Leveringlijst',
    DeliveryTimeReport: 'Rapportage levertijd',
    Domain: 'Domeinen',
    DomainUser: 'Domeinaccounts',
    EventLog: 'Event log',
    ExactInstance: 'Exact instanties',
    ExternalApiUser: 'Externe API gebruikers',
    ExternalInvoice: 'Externe facturen',
    Fabric: 'Stoffen',
    FabricOrder: 'Stoforders',
    FabricReport: 'Stofgegevens',
    FabricStockReport: 'Voorraadoverzichten',
    Finish: 'Afwerkingen',
    FinishType: 'Afwerkingssoorten',
    GLAccount: 'Grootboekrekeningen',
    HemaPendingProject: 'HEMA pending projects',
    InteriorDecorator: 'Woninginrichters',
    InternalInvoice: 'Interne facturen',
    InvoiceSummary: 'Factuuroverzichten',
    Language: 'Talen',
    LinkDomainDeliveryPrice: 'Bezorgprijzen',
    LinkPriceListItem: 'Koppeling prijstlijstitems',
    Option: 'Optielijsten',
    Order: 'Orders',
    OrderLineDeliveryDate: 'Uitleverdatum orders',
    OrderLinePrice: 'Orderregelprijzen',
    OrderLineStatus: 'Order statussen',
    OrderLineStatusSummary: 'Statusoverzicht dashboard',
    OrderPickList: 'Orderpicklijsten',
    OrderReport: 'Datacomlijst',
    OrderReportVolume: 'Banenlijst',
    OrderedMetersReport: 'Rapportage bestelde meters',
    ParcelType: 'Verpakkingseenheden',
    Permission: 'Permissies',
    PriceListItem: 'Prijslijstitems',
    PriceListItemPrice: 'Prijslijstitem prijzen',
    PriceListMatrix: 'Prijslijstmatrices',
    PrintTemplate: 'Printtemplates',
    Printer: 'Printers',
    PrinterClient: 'Printer clients',
    Product: 'Artikelen',
    ProductGroup: 'Productgroepen',
    ProductType: 'Artikelsoorten',
    ProductionPlanning: 'Selecties aanmaken',
    ProductionPlanningSeries: 'Productieseries',
    QueuedKwantumOrder: 'Kwantum orders',
    ReasonStockCorrection: 'Redenen voorraadcorrecties',
    ReturnCause: 'Retouroorzaken',
    ReturnReason: 'Retour types',
    ReturnReasonCategory: 'Retourredencategorieën',
    ReturnReport: 'Retourlijst',
    Role: 'Rollen',
    SetStockTask: 'Herbereken beschikbare voorraad t.o.v. orders',
    Shipment: 'Transportorders',
    ShipmentListToBlackHole: 'Transportlijst naar zwarte gat versturen',
    ShipmentListType: 'Types verzendlijst',
    Special: 'Specials',
    StandardUser: 'Standaardgebruikers',
    Stock: 'Voorraad',
    StockCorrection: 'Voorraadcorrecties',
    StockLocation: 'Voorraadlocaties',
    Store: 'Vestigingen',
    StoreAttribute: 'Vestigingskenmerken',
    StoreFabric: 'Stoffenlijst vestiging',
    StoreType: 'Vestigingstypes',
    StoreUser: 'Logins voor winkels',
    Supplier: 'Leveranciers',
    TemplateImage: 'Bonpictogrammen',
    Translation: 'Vertalingen',
    TransportCompany: 'Transporteurs',
    TransportOrder: 'Verzendlijsten',
    TransportRoute: 'Transportroutes',
    Truck: 'Voertuigen',
    Unit: 'Eenheden',
    User: 'Gebruikers',
    VatType: 'BTW-types',
    Workshop: 'Ateliers',
    Yarn: 'Garen',
    execute: 'Uitvoeren',
    none: 'Geen',
    pageIsReadonly: 'U heeft geen rechten om de gegevens op deze pagina te wijzigen.',
    read: 'Lezen',
    roles: 'Uw rollen',
    selectPlaceholder: 'Kies het toegangsniveau',
    switchRoles: 'Rol wisselen',
    tabPermissions: 'Permissies',
    tabTaskTypes: 'Taaksoorten',
    write: 'Schrijven'
  },
  pickrec: {
    chooseEntryFor: 'Selecteer "{caption}"',
    itemNotFound: "'{caption}' niet gevonden",
    suggestionsMayBeMore: 'Er zijn mogelijk meer zoekresultaten',
    suggestionsRestCount: 'Er zijn {count} meer zoekresultaten'
  },
  planning: {
    alreadyPlanned: 'Binnen de huidige productieplanning is al een planning gemaakt voor deze productgroep.',
    amount: 'Aantal',
    basedOnOrderDate: 'Op orderdatum',
    capacity: 'Capaciteit',
    capacityRequired: 'Capaciteit is vereisd',
    capacityStep: 'Capaciteit invoeren',
    confirmYear: 'Planning maken voor',
    considerStoreAttributes: 'Series op vestigingskenmerk',
    curtainsMeters: 'meters overgordijn',
    curtainsRoomHigh: 'Overgordijnen kamerhoog',
    cuttings: 'Coupage',
    distributionCenterAvailableAmountInMeters: 'Voorraad D.C. (m)',
    domainAvailableAmountInMeters: 'Voorraad totaal (m)',
    estimatedDeliveryDate: 'Verwachte leverdatum',
    excludeDiverseLining: 'Diverse voering uitsluiten',
    excludedFabricsWillBeIgnored: 'Uitgesloten stoffen worden genegeerd (geconfigureerd in het atelier)',
    excludedStoreAttributes: 'Uitgesloten vestigingskenmerken',
    excludedStores: 'Uitgesloten vestigingen',
    exportSelection: 'Exporteer selecties',
    fabricCode: 'Artikelnummer',
    fabricDescription: 'Stof',
    generate: 'Genereren',
    group: 'Groep',
    inefficientPlanning: 'Je gaat nu inefficiënt plannen',
    installationService: 'Ophangservice',
    makeCurrent: 'Start planning',
    makeSelection: 'Selectie maken',
    makeSeries: 'Series maken',
    meters: 'Meters',
    netCurtainsMeters: 'meters vitrage',
    netCurtainsRoomHigh: 'Vitrages kamerhoog',
    newProposalWithFilter: 'Nieuw voorstel met filter',
    noStock: 'Geen voorraad',
    oldestOrder: 'Oudste order',
    orderAmount: 'Aantal orders',
    orders: 'Aantal familieorders',
    ordersToPlan: 'Te plannen orders',
    panels: 'Banen',
    pieces: 'Stuks',
    plan: 'Plannen',
    planAgain: 'Nog een keer plannen',
    planningDateRange: 'Deze planning bevat orders tussen de volgende data',
    planningInProgress: 'Er is al een planning bezig in de week van ',
    preselectionMade:
      "Er is al een selectie bezig voor deze groep. Klik op 'plannen' om verder te gaan met deze selectie, klik op 'reset groep' om opnieuw te beginnen.",
    requiredCapacity: 'Benodigde capaciteit',
    requiredFabric: 'Benodigde stof (m)',
    reset: 'Reset groep',
    romanBlinds: 'Vouwgordijnen',
    samples: 'Alleen showbanen',
    selectionStep: 'Selecties maken',
    series: 'Serie',
    seriesNumber: 'Serienummer',
    seriesStep: 'Series maken',
    storeAttribute: 'Vestigingskenmerk',
    strictlySelectedYarns: 'Alleen geselecteerde garen',
    tabGeneral: 'Planning capaciteit',
    temporarySave: 'Tijdelijk opslaan',
    tickets: 'Bonnen',
    toPlan: 'Te plannen',
    total: 'Totaal',
    weekNumber: 'Weeknummer',
    workshopAvailableAmountInMeters: 'Voorraad atelier (m)',
    workshopID: 'Atelier',
    workshopOrder: '#',
    yarnDescription: 'Garen'
  },
  planningOption: {
    CurtainRoomHigh: 'Overgordijnen kamerhoog',
    CurtainRoomHighUnit: 'm',
    Cutting: 'Coupage',
    CuttingUnit: 'stuks',
    NetCurtainRoomHigh: 'Vitrages kamerhoog',
    NetCurtainRoomHighUnit: 'meter',
    Panel: 'Banen',
    PanelUnit: 'banen',
    RomanBlind: 'Vouwgordijnen',
    RomanBlindUnit: 'stuks',
    Tieback: 'Embrasses',
    TiebackUnit: 'stuks'
  },
  priceListItem: {
    currentPrice: 'Huidige prijs',
    descriptionInvoice: 'Factuurbeschrijving',
    descriptionInvoiceForeign: 'Factuurbeschrijving internationaal',
    externalOnlyYN: 'Op interne factuur',
    gtinNumber: 'GTIN-nummer',
    height: 'Hoogte',
    intercompany: 'IC',
    laborPrice: 'Maakloon',
    markUpType: 'Toeslagsoort',
    markUpYN: 'Toeslag',
    matrixYN: 'Matrix',
    maximumLength: 'Maximumhoogte',
    maximumWidth: 'Maximumbreedte',
    minimumLength: 'Minimumhoogte',
    minimumWidth: 'Minimumbreedte',
    newPrice: 'Nieuwe prijs',
    nextPrice: 'Volgende prijs',
    priceListItems: 'Prijslijstitems',
    productCode: 'Productcode',
    stepSizeLength: 'Stapgrootte hoogte',
    stepSizeWidth: 'Stapgrootte breedte',
    tabCountryMatrix: 'Prijsmatrix ateliers',
    tabGeneral: 'Algemeen',
    tabMatrix: 'Prijsmatrix',
    tabPrices: 'Prijslijst',
    unit: 'Eenheid',
    width: 'Breedte'
  },
  priceListItemPrice: {
    calculatePrices: 'Bereken prijzen',
    consumerPrice: 'Consumentprijs',
    consumerPrices: 'Consumentprijzen',
    currency: 'Valuta',
    effectiveDate: 'Ingangsdatum',
    expirationDate: 'Verloopdatum',
    laborPrice: 'Maakloon',
    priceType: 'Prijssoort',
    rounding: 'Afronding',
    showPrices: 'Toon prijzen',
    workshopPrices: 'Atelierprijzen'
  },
  printTemplate: {
    domains: 'Domeinen',
    productGroup: 'Productgroep',
    templateDocument: 'Bestandsnaam',
    versionNumber: 'Versie'
  },
  printer: {
    printProvider: 'Provider',
    statusOption: 'Status',
    statusReceivedAt: 'Status ontvangen op',
    statusText: 'Ontvangen status',
    typeOption: 'Printertype'
  },
  product: {
    measurementInMm: 'Maat (mm)',
    ownCode: 'Eigen code',
    ownProduct: 'Eigen product',
    printOnTicket: 'Toon op bon',
    stockItem: 'Voorraadartikel'
  },
  productGroup: {
    active: 'Actief',
    addWeights: 'Loodjes toevoegen',
    defaultFinishQuantityFormula: 'Standaard formule voor aantal (uit afwerking)',
    description: 'Beschrijving',
    finishTypes: 'Afwerkingssoorten',
    maximumFabricWidthInCm: 'Maximum stofbreedte ongevoerd (cm)',
    maximumHeightInCm: 'Maximum hoogte ongevoerd (cm)',
    maximumLinedFabricWidthInCm: 'Maximum stofbreedte gevoerd (cm)',
    maximumLinedHeightInCm: 'Maximum hoogte gevoerd (cm)',
    maximumLinedWidthInCm: 'Maximum breedte gevoerd (cm)',
    maximumNumberOfLinedPanels: 'Maximum aantal banen gevoerd',
    maximumNumberOfPanels: 'Maximum aantal banen ongevoerd',
    maximumWidthInCm: 'Maximum breedte ongevoerd (cm)',
    minimumHeightInCm: 'Minimum hoogte (cm)',
    minimumNumberOfPanels: 'Minimaal aantal banen',
    minimumWidthInCm: 'Minimum breedte (cm)',
    parcelType: 'Verpakkingseenheid',
    productGroupDescription: 'Beschrijving',
    productGroupTypeOption: 'Berekeningen volgens',
    productGroups: 'Productgroepen',
    shipmentListType: 'Type verzendlijst',
    tabPossibleFabricProductTypes: 'Mogelijke stoffen',
    tabPossibleFinishes: 'Mogelijke afwerkingen'
  },
  productType: {
    fabricTypeOption: 'Stofsoort',
    measurementRequiredYN: 'Maat verplicht',
    products: 'Artikelen',
    velours: 'Velours'
  },
  reasonStockCorrection: {
    reasonStockCorrectionOption: 'Categorie'
  },
  report: {
    deliveryReport: 'Leveringlijst',
    export: 'Exporteer lijst',
    orderReport: 'Banenlijst'
  },
  request: {
    networkError: 'Het netwerk is op dit moment niet bereikbaar.'
  },
  return: {
    return: 'Retour',
    returnCause: 'Retouroorzaak',
    returnPriceListItem: 'Te koppelen prijs',
    returnReason: 'Retourreden',
    returnReasonCategory: 'Retourredencategorie',
    returnReasonCategoryCode: 'Rapportage nummer',
    returnReasonCharacter: 'Rapportage letter',
    returnReasons: 'Retourredenen',
    returnType: 'Retourtype'
  },
  route: {
    Table: 'Table',
    avatarUpload: 'Avatar Upload',
    clipboardDemo: 'Clipboard',
    complexTable: 'Complex Table',
    componentIndex: 'Introduction',
    componentMixin: 'Mixin',
    components: 'Components',
    countTo: 'CountTo',
    createClient: 'Klant aanmaken',
    createCollection: 'Stofboek aanmaken',
    createCompany: 'Bedrijf aanmaken',
    createContactPerson: 'Contactpersoon aanmaken',
    createCountry: 'Land aanmaken',
    createCulture: 'Culture aanmaken',
    createCurrency: 'Valuta aanmaken',
    createDomain: 'Domein aanmaken',
    createDomainUser: 'Domeinaccount aanmaken',
    createExactInstance: 'Exact instantie aanmaken',
    createExternalApiUser: 'Externe API gebruiker aanmaken',
    createFabric: 'Stof aanmaken',
    createFabricOrder: 'Stoforder aanmaken',
    createFabricOrderLine: 'Stoforderregel aanmaken',
    createFinish: 'Afwerking aanmaken',
    createFinishType: 'Afwerkingssoort aanmaken',
    createInteriorDecorator: 'Woninginrichter aanmaken',
    createInvalidFinishCombination: 'Niet-toegestane afwerkingscombinatie aanmaken',
    createLanguage: 'Taal aanmaken',
    createLinkDomainDeliveryPrice: 'Bezorgprijs aanmaken',
    createLinkDomainProductGroup: 'Koppeling domein productgroep bewerken',
    createLinkDomainProductGroupFinish: 'Domeinspecifieke afwerking aanmaken',
    createLinkPriceListItem: 'Koppeling prijslijstitem aanmaken',
    createLinkReasonStockCorrectionDomain: 'Koppeling met domein aanmaken',
    createLinkStoreCollection: 'Stofboek toekennen',
    createOrder: 'Order aanmaken',
    createOrderLine: 'Order aanmaken',
    createOrderLinePrice: 'Orderregelprijs aanmaken',
    createOrderLineStatus: 'Order status aanmaken',
    createParcelType: 'Verpakkingseenheid aanmaken',
    createPriceListItem: 'Prijslijstitem aanmaken',
    createPriceListItemPrice: 'Prijslijstitem prijs aanmaken',
    createPriceListMatrix: 'Prijslijstmatrix aanmaken',
    createPrintTemplate: 'Template aanmaken',
    createPrinter: 'Printer aanmaken',
    createPrinterClient: 'Printer client aanmaken',
    createProduct: 'Artikel aanmaken',
    createProductGroup: 'Productgroep aanmaken',
    createProductType: 'Artikelsoort aanmaken',
    createProductionPlanning: 'Selectie aanmaken',
    createQueuedKwantumOrder: 'Kwantum order aanmaken',
    createReasonStockCorrection: 'Reden voorraadcorrectie aanmaken',
    createReturnCause: 'Retouroorzaak aanmaken',
    createReturnReason: 'Retourreden aanmaken',
    createReturnReasonCategory: 'Retourredencategorie aanmaken',
    createRole: 'Rol aanmaken',
    createShipmentListType: 'Type verzendlijst aanmaken',
    createSpecial: 'Special aanmaken',
    createStandardUser: 'Gebruiker aanmaken',
    createStock: 'Voorraad aanmaken',
    createStockLocation: 'Voorraadlocatie aanmaken',
    createStore: 'Vestiging aanmaken',
    createStoreAttribute: 'Kenmerk aanmaken',
    createStoreType: 'Vestigingstype aanmaken',
    createSupplier: 'Leverancier aanmaken',
    createTemplateImage: 'Bonpictogram aanmaken',
    createTransportCompany: 'Transporteur aanmaken',
    createTransportRoute: 'Transportroute aanmaken',
    createTruck: 'Voertuig aanmaken',
    createUnit: 'Eenheid aanmaken',
    createUrgentSeries: 'Spoedserie aanmaken',
    createUser: 'Gebruiker aanmaken',
    createVatType: 'BTW-soort aanmaken',
    createVatTypeRate: 'BTW-tarief aanmaken',
    createWorkshop: 'Atelier aanmaken',
    createYarn: 'Garen aanmaken',
    createglAccount: 'Grootboekrekeningnummer aanmaken',
    customTreeTable: 'Custom TreeTable',
    dashboard: 'Dashboard',
    directivePermission: 'Directive Permission',
    documentation: 'Documentation',
    dragDialog: 'Drag Dialog',
    dragTable: 'Drag Table',
    dropzone: 'Dropzone',
    dynamicTable: 'Dynamic Table',
    editClient: 'Klant bewerken',
    editCollection: 'Stofboek bewerken',
    editCompany: 'Bedrijf bewerken',
    editConfiguration: 'Instelling bewerken',
    editContactPerson: 'Bewerk contactpersoon',
    editCountry: 'Land bewerken',
    editCulture: 'Culture bewerken',
    editCurrency: 'Valuta bewerken',
    editDomain: 'Domein bewerken',
    editDomainUser: 'Domeinaccount bewerken',
    editExactInstance: 'Exact instantie bewerken',
    editExternalApiUser: 'Externe API gebruiker bewerken',
    editFabric: 'Stof bewerken',
    editFabricOrder: 'Bewerk stoforder',
    editFabricOrderLine: 'Stoforderregel bewerken',
    editFabricRolls: 'Stofrollen bewerken',
    editFinish: 'Afwerking bewerken',
    editFinishType: 'Afwerkingssoort bewerken',
    editInteriorDecorator: 'Woninginrichter bewerken',
    editInvalidFinishCombination: 'Niet-toegestane afwerkingscombinatie bewerken',
    editLanguage: 'Taal bewerken',
    editLinkDomainDeliveryPrice: 'Bezorgprijs bewerken',
    editLinkDomainProductGroup: 'Koppeling domein productgroep bewerken',
    editLinkDomainProductGroupFinish: 'Bewerk domeinspecifieke afwerking',
    editLinkPriceListItem: 'Koppeling prijslijstitem bewerken',
    editLinkReasonStockCorrectionDomain: 'Koppeling met domein bewerken',
    editLinkStoreCollection: 'Stofboek toekennen',
    editOrder: 'Order bewerken',
    editOrderLine: 'Order bewerken',
    editOrderLinePrice: 'Orderregelprijs bewerken',
    editOrderLineStatus: 'Order status bewerken',
    editOrderPickList: 'Orderpicklijst bewerken',
    editParcelType: 'Verpakkingseenheid bewerken',
    editPriceListItem: 'Prijslijstitem bewerken',
    editPriceListItemPrice: 'Prijslijstitem prijs bewerken',
    editPriceListMatrix: 'Prijslijstmatrix bewerken',
    editPrintTemplate: 'Template bewerken',
    editPrinter: 'Printer bewerken',
    editPrinterClient: 'Printer client bewerken',
    editProduct: 'Artikel bewerken',
    editProductGroup: 'Productgroep bewerken',
    editProductType: 'Artikelsoort bewerken',
    editProductionPlanning: 'Selectie bewerken',
    editQueuedKwantumOrder: 'Kwantum order bewerken',
    editReasonStockCorrection: 'Reden voorraadcorrectie bewerken',
    editReturnCause: 'Retouroorzaak bewerken',
    editReturnReason: 'Retourreden bewerken',
    editReturnReasonCategory: 'Retourredencategorie bewerken',
    editRole: 'Rol bewerken',
    editSeries: 'Serie bewerken',
    editShipmentListType: 'Type verzendlijst bewerken',
    editSpecial: 'Special bewerken',
    editStandardUser: 'Gebruiker bewerken',
    editStock: 'Voorraad bewerken',
    editStockLocation: 'Voorraadlocatie bewerken',
    editStore: 'Vestiging bewerken',
    editStoreAttribute: 'Kenmerk bewerken',
    editStoreType: 'Vestigingstype bewerken',
    editStoreUser: 'Gebruiker bewerken',
    editSupplier: 'Leverancier bewerken',
    editTemplateImage: 'Bewerk bonpictogram',
    editTranslation: 'Vertaling bewerken',
    editTransportCompany: 'Transporteur bewerken',
    editTransportOrder: 'Verzendlijst bewerken',
    editTransportRoute: 'Transportroute bewerken',
    editTruck: 'Voertuig bewerken',
    editUnit: 'Eenheid bewerken',
    editUser: 'Gebruiker bewerken',
    editVatType: 'BTW-soort bewerken',
    editVatTypeRate: 'BTW-tarief bewerken',
    editWorkshop: 'Atelier bewerken',
    editYarn: 'Garen bewerken',
    editglAccount: 'Grootboekrekeningnummer bewerken',
    errorLog: 'Error Log',
    errorPages: 'Error Pages',
    example: 'Example',
    excel: 'Excel',
    exportExcel: 'Export Excel',
    exportZip: 'Export Zip',
    externalLink: 'External Link',
    form: 'Form',
    guide: 'Guide',
    home: 'Home',
    i18n: 'I18n',
    icons: 'Icons',
    inlineEditTable: 'Inline Edit',
    introduction: 'Introduction',
    jsonEditor: 'JSON Editor',
    markdown: 'Markdown',
    menu_admin: 'Beheer',
    menu_admin_accesslog: 'Access Log',
    menu_admin_application: 'Applicatie',
    menu_admin_appsettings: 'Appsettings',
    menu_admin_bans: 'Bans',
    menu_admin_collections: 'Stofboeken',
    menu_admin_company_structure: 'Bedrijfsstructuur',
    menu_admin_configuration: 'Instellingen',
    menu_admin_countries: 'Landen',
    menu_admin_domain_users: 'Domeinaccounts',
    menu_admin_eventlog: 'Event Log',
    menu_admin_exact_instances: 'Exact instanties',
    menu_admin_external_api_users: 'Externe API logins',
    menu_admin_fabric_order: 'Stoforders',
    menu_admin_fabrics: 'Stoffenlijst',
    menu_admin_finishtypes: 'Afwerkingen',
    menu_admin_interior_decorators: 'Woninginrichters',
    menu_admin_invoicing: 'Facturatie',
    menu_admin_languages: 'Talen',
    menu_admin_masterdata: 'Basisgegevens',
    menu_admin_options: 'Keuzelijsten',
    menu_admin_ordering_api_users: 'Order API logins',
    menu_admin_penalties: 'Penalties',
    menu_admin_pricing: 'Prijzen',
    menu_admin_printtemplates: 'Templates orderbonnen',
    menu_admin_productgroups: 'Productgroepen',
    menu_admin_production: 'Productie',
    menu_admin_products: 'Artikelen',
    menu_admin_producttypes: 'Artikelen',
    menu_admin_reasonstockcorrections: 'Redenen voorraadcorrecties',
    menu_admin_roles: 'Rollen',
    menu_admin_store_users: 'Winkels',
    menu_admin_templateimages: 'Bonpictogrammen',
    menu_admin_translations: 'Vertalingen',
    menu_admin_transport: 'Transport',
    menu_admin_units: 'Eenheden',
    menu_admin_users: 'Gebruikers',
    menu_admin_vattypes: 'BTW-soorten',
    menu_admin_yarns: 'Garen',
    menu_client_management: 'Klantbeheer',
    menu_client_sales_report: 'Omzetlijst',
    menu_clients: 'Klanten',
    menu_companies: 'Bedrijven',
    menu_component_list: 'Componentenlijst',
    menu_cultures: 'Cultures',
    menu_currencies: 'Valuta',
    menu_delivery_report: 'Leveringlijst',
    menu_delivery_time_report: 'Levertijd',
    menu_domains: 'Domeinen',
    menu_external_invoices: 'Externe facturen',
    menu_fabric_inventory: 'Voorraadstanden',
    menu_fabric_management: 'Stoffen',
    menu_fabric_report: 'Stofgegevens',
    menu_fabric_stockcorrections: 'Voorraadcorrectie',
    menu_fabric_stockreport: 'Voorraadoverzicht',
    menu_hema: 'HEMA',
    menu_internal_invoices: 'Interne facturen',
    menu_invoice_summary: 'Factuuroverzicht',
    menu_invoicing: 'Facturatie',
    menu_link_domain_delivery_prices: 'Bezorgprijzen',
    menu_link_price_list_items: 'Koppeling Prijstlijstitems',
    menu_matrix_prices: 'Matrixprijzen',
    menu_order_drafts: 'Concepten',
    menu_order_handling: 'Orders',
    menu_order_line_prices: 'Orderregelprijzen',
    menu_order_line_statuses: 'Order statussen',
    menu_order_pick_list: 'Orderpicklijst aanmaken',
    menu_order_pick_list_complete: 'Orderpicklijst verstuurd ',
    menu_order_report: 'Datacomlijst',
    menu_order_report_volume: 'Banenlijst',
    menu_ordered_meters_report: 'Bestelde meters',
    menu_orderlines: 'Orders',
    menu_orders: 'Orderlijst',
    menu_parcel_types: 'Verpakkingseenheden',
    menu_planning: 'Planning',
    menu_price_list_item_prices: 'Prijslijstitem prijzen',
    menu_price_list_items: 'Prijslijstitems',
    menu_price_list_matrices: 'Prijslijstmatrices',
    menu_printer_clients: 'Printer Clients',
    menu_production_planning: 'Selecteren',
    menu_queued_kwantum_orders: 'Kwantum Orders',
    menu_reports: 'Rapportage',
    menu_return_causes: 'Retouroorzaken',
    menu_return_report: 'Retourlijst',
    menu_return_type_categories: 'Retourredenen',
    menu_return_types: 'Retour Types',
    menu_series: 'Series',
    menu_shipment_list_types: 'Types Verzendlijst',
    menu_show_orders: 'Show samples',
    menu_specials: 'Specials',
    menu_status_list: 'Statuslijst',
    menu_store: 'Vestiging',
    menu_store_fabrics: 'Stoffen',
    menu_store_orders: 'Orders',
    menu_store_shipment_list: 'Verzendlijst',
    menu_stores: 'Vestigingen',
    menu_suppliers: 'Leveranciers',
    menu_transport: 'Transport',
    menu_transport_companies: 'Transporteurs',
    menu_transport_list: 'Verzendlijsten',
    menu_transport_planning: 'Verzendlijsten aanmaken',
    menu_transport_routes: 'Transportroutes',
    menu_trucks: 'Voertuigen',
    menu_workshops: 'Ateliers',
    page401: '401',
    page403: '403',
    page404: '404',
    pagePermission: 'Page Permission',
    permission: 'Permission',
    selectExcel: 'Export Selected',
    splitPane: 'SplitPane',
    sticky: 'Sticky',
    tab: 'Tab',
    theme: 'Theme',
    tinymce: 'Tinymce',
    treeTable: 'Tree Table',
    uploadExcel: 'Upload Excel',
    userSettings: 'Instellingen gebruiker',
    zip: 'Zip'
  },
  series: {
    addOrderNumber: 'Ordernummer toevoegen',
    addOrderNumbers: 'Ordernummers toevoegen',
    amount: 'Aantal',
    amountOfEmbraces: 'Embrasses',
    amountOfHangers: 'Hangers',
    amountOfOrderLines: 'Orders',
    amountOfOrders: 'Familyorders',
    amountOfParcels: 'Verpakkingen',
    amountOfRings: 'Ringen',
    amountOfWaves: 'Waveplooien',
    bulkActionLabel: 'Wijzig geselecteerde orders',
    confirmDelete: 'Weet u zeker dat u de geselecteerde orders uit de serie wilt verwijderen?',
    confirmPrint: 'Weet u zeker dat u de geselecteerde bonnen wilt printen?',
    confirmUpdate: 'Weet u zeker dat u de geselecteerde orders wilt bijwerken?',
    domainName: 'Domein',
    doubleOrderNumber: 'Dubbel ordernummer',
    numberOfMeters: 'Aantal meter',
    numberOfPanels: 'Aantal banen',
    orderNumbersAdded: 'Ordernummers zijn toegevoegd',
    orderNumbersNotAdded: 'Ordernummers konden niet worden toegevoegd',
    pieces: 'Stuks',
    printTickets: 'Bonnen printen',
    quantity: 'Aantal',
    series: 'Series',
    seriesDescription: 'Serie',
    seriesNumber: 'Serienummer',
    seriesPrintError: 'Niet alle bonnen konden worden afgedrukt',
    seriesPrintStart: '{toBePrintedCount} bonnen uit deze serie worden afgedrukt',
    seriesPrintSuccess: 'De bonnen zijn naar {printDestination} gestuurd',
    seriesStatus: 'Status',
    ticketsAlreadyPrintedCancel: 'Ja, alles opnieuw afdrukken',
    ticketsAlreadyPrintedConfirm: 'Nee, alleen de nieuwe afdrukken',
    ticketsAlreadyPrintedMessage:
      '{printedTickets} van de {totalTickets} bonnen zijn al afgedrukt. Wilt u deze opnieuw afdrukken?',
    ticketsAlreadyPrintedTitle: 'Waarschuwing',
    typeOfOrders: 'Soorten orders',
    unit: 'Eenheid',
    updateOrderLines: 'Bijwerken',
    weekNumber: 'Week',
    workshopName: 'Atelier'
  },
  size: {
    medium: 'Normaal',
    mini: 'Kleinst',
    small: 'Klein'
  },
  special: {
    descriptionOnTicket: 'Beschrijving bon',
    specialType: 'Special type'
  },
  statusList: {
    allOrders: 'Alle orders',
    fabricCode: 'Artikelnummer',
    fabricName: 'Stofnaam',
    hangers: 'Hangers',
    notScanned: 'Niet gescand',
    scanned: 'Gescand',
    seriesNumber: 'Serienummer',
    seriesPlaceholder: 'Serienummers [1-5,7,10-12]',
    status: 'Status',
    storeCode: 'Vestigingsnummer',
    storeName: 'Vestigingsnaam',
    subStatus: 'Substatus',
    ticketNumber: 'Bonnummer'
  },
  stock: {
    mutatedAt: 'Boekdatum',
    mutationInMeters: 'Aantal meters',
    mutationReason: 'Reden',
    onlyShowFabricsWithAvailableStock: 'Toon alleen stoffen met beschikbare voorraad',
    positionCode: 'Locatiecode',
    stockAvailable: 'Beschikbare voorraad (m)',
    stockBlocked: 'Geblokkeerde voorraad (m)',
    stockLocationName: 'Voorraadlocatie',
    stockReserved: 'Onderhanden werk (m)',
    stockSold: 'Verkochte voorraad (m)'
  },
  stockCorrection: {
    chooseReasonStockCorrection: 'Reden voorraadcorrectie',
    clearInput: 'Invoer wissen',
    clearInputSuggestion: 'Verwerk of wis uw invoer om te wisselen van voorraadlijst',
    clearInputWarning: 'Al uw invoer zal gewist worden',
    correction: 'Correctie (m)',
    createdAt: 'Boekdatum',
    mutation: 'Stofboeking (m)',
    noInput: 'Er zijn geen correcties ingevoerd',
    processStockCorrection: 'Voorraadcorrecties verwerken',
    reason: 'Reden',
    reasonRequired: 'Een reden is vereist',
    remarks: 'Opmerking',
    saveSelection: 'Correctie opslaan',
    selectAStockLocation: 'Selecteer een voorraadlocatie en een correctiereden',
    selectTransferLocation: 'Selecteer een voorraadlocatie om naar over te boeken',
    setStock: 'Herbereken beschikbare voorraad t.o.v. orders',
    stockLocationName: 'Voorraadlocatie',
    stockProductCode: 'Artikelnummer',
    stockProductDescription: 'Stof',
    targetStockLocation: 'Overboeken naar',
    transferToSameLocationError: 'De huidige locatie is gelijk aan de overboeklocatie'
  },
  store: {
    attribute: 'Kenmerk',
    code: 'Vestigingsnummer',
    collection: 'Stofboek',
    consumerOrderTicketURL: 'URL voor maken klantbon',
    domain: 'Domein',
    height: 'Hoogte (cm)',
    name: 'Vestigingsnaam',
    noConsumerOrderTicketURLConfigured: 'Kan klantbon niet tonen. Neem contact op met Content',
    tabContactPersons: 'Contactpersonen',
    tabGeneral: 'Algemeen',
    tabSettings: 'Instellingen',
    tabStoreCollections: 'Stofboeken',
    type: 'Vestigingstype'
  },
  storeFabric: {
    availableStockInM: 'Voorraad (m)',
    estimatedNewStock: 'Nieuwe voorraad verwacht',
    soldStockInM: 'Verkocht (m)'
  },
  storeUser: {
    clientName: 'Klant',
    storeCode: 'Vestigingsnummer',
    storeName: 'Vestiging'
  },
  supplier: {
    agentName: 'Naam agent',
    code: 'Leveranciersnummer',
    domain: 'Domein',
    tabContactPersons: 'Contactpersonen',
    tabGeneral: 'Algemeen'
  },
  table: {
    actions: 'Acties',
    searchDatePlaceholder: 'Typ of selecteer',
    searchPlaceholder: 'Typ om te zoeken',
    searchSelectPlaceholder: 'Selecteer om te zoeken',
    withRestriction: 'Met beperking'
  },
  tagsView: {
    close: 'Sluiten',
    closeAll: 'Alle sluiten',
    closeOthers: 'Andere sluiten',
    refresh: 'Verversen'
  },
  templateImage: {
    templateDocument: 'Afbeelding (png)',
    templateImageTypeOption: 'Type pictogram'
  },
  translation: {
    code: 'Vertalingcode'
  },
  transport: {
    loadingAddress: 'Laadadres',
    loadingAddressCode: 'Code laadadres',
    loadingTimeRange: 'Laadtijden (van, tot)',
    parcelTypes: 'Verpakkingseenheden',
    shipperNumber: 'Verladernummer winkelbezorging',
    shipperNumberHomeDelivery: 'Verladernummer thuisbezorging',
    transportCompany: 'Transporteur',
    unloadingAddressCode: 'Code losadres',
    unloadingTimeRange: 'Lostijden (van, tot)'
  },
  transportOrder: {
    confirmAlreadyExportedExport: 'Deze verzendlijst is al verzonden. Wilt u deze opnieuw verzenden?',
    confirmExport: 'Wilt u deze verzendlijst versturen naar het transportbedrijf?',
    confirmExportToBlackHole: 'Wilt u deze verzendlijst laten verdwijnen in het zwarte gat?',
    confirmFixDeliveryDate: 'Wilt u de uitleverdatum van alle orders op deze verzendlijst bijwerken?',
    countryCode: 'Land',
    createShipments: 'Verzendlijsten maken',
    domainOrderNumberPrefix: 'Domein',
    exportShipments: 'Verzenden',
    exportedAt: 'Verzendlijst verzonden',
    exportedTo: 'Naar',
    fromDate: 'Orders van',
    hangers: 'Hangers',
    isExcluded: 'Wordt niet verzonden',
    isIncluded: 'Wordt verzonden',
    parcels: 'Hangers/pakketten',
    planningDateRange: 'Deze lijst bevat orders gescand tussen de volgende data',
    reference: 'Referentie',
    scannedAt: 'Tijdstip gescand',
    seriesNumber: 'Serienummer',
    shipmentAt: 'Tijdstip transport',
    shipmentListTypeName: 'Type verzendlijst',
    shipments: 'Verzendingen',
    shipmentsCreated: 'De verzendlijsten zijn aangemaakt',
    shipmentsExportError: 'De verzendlijst kon niet worden verzonden naar het transportbedrijf',
    shipmentsExported: 'De verzendlijst is verzonden naar het transportbedrijf',
    status: 'Status',
    storeAttribute: 'Vestigingskenmerk',
    storeCode: 'Vestigingsnummer',
    subStatus: 'Substatus',
    ticketNumber: 'Bonnummer',
    truckIdentifier: 'Voertuig',
    untilDate: 'Orders tot en met',
    updateOrders: 'Orders bijwerken',
    workshops: 'Atelier(s)'
  },
  transportRoute: {
    code: 'Routecode',
    countryCode: 'Land',
    postalCodeFrom: 'Postcode van',
    postalCodeTo: 'Postcode tot'
  },
  unit: {
    meters: 'meters',
    panels: 'banen',
    pieces: 'stuks'
  },
  user: {
    avatar: 'Profielafbeelding',
    avatarInfo: 'URL naar profielafbeelding',
    newPassword: 'Nieuw wachtwoord',
    newPasswordInfo: 'Laat leeg als u uw wachtwoord niet wilt wijzigen',
    oldPassword: 'Huidig wachtwoord',
    oldPasswordInfo: 'Voer ter controle uw huidige wachtwoord in',
    oldPasswordInvalid: 'U heeft niet het correcte huidige wachtwoord opgegeven',
    passwordChanged: 'Uw wachtwoord is aangepast',
    repeatPassword: 'Herhaal wachtwoord',
    repeatPasswordInfo: 'Herhaal ter controle uw nieuwe wachtwoord',
    roles: 'Rollen',
    workingAt: 'Werkzaam bij'
  },
  validation: {
    cannotExcludePreferredWorkshop: 'Het voorkeursatelier kan niet worden uitgesloten',
    complexity: 'Kies complexiteit',
    countryRequiredForDelivery: 'Land is verplicht bij thuisbezorgen',
    ean: 'Deze barcode is incorrect',
    email: 'Dit is een ongeldig e-mailadres',
    error: {
      alphanumeric: 'Minstens 1 symbool is vereist',
      digit: 'Minstens 1 getal is vereist',
      invalidFormula: 'Eén of meerdere formules bevat een fout: {errorMessage}',
      isFromDatabase: 'Het wachtwoord kan niet worden gevalideerd, omdat de server niet bereikbaar is.',
      itemNotFound: 'Bestand is reeds verwijderd.',
      length: 'Minstens {count} karakters zijn vereist',
      lowercase: 'Minstens 1 kleine letter is vereist',
      passwordComplexity: 'Het wachtwoord voldoet niet aan de vereiste complexiteit',
      uppercase: 'Minstens 1 hoofdletter is vereist'
    },
    formValidationFailed: 'Dit formulier bevat fouten. Controleer uw invoer en probeer het opnieuw',
    notAllWorkshopsCanBeExcluded: 'Er moet tenminste 1 atelier beschikbaar zijn',
    numeric: 'Alleen cijfers toegestaan',
    oldPasswordRequired: 'Vul het oude wachtwoord in',
    repeatPasswordMismatch: 'Twee wachtwoorden komen niet overeen',
    required: 'Dit veld is vereist'
  },
  vat: {
    countryCode: 'Land',
    countryID: 'Land',
    glCodePurchase: 'Btw-code inkoop',
    glCodeSales: 'Btw-code verkoop',
    invoiceText: 'Tekst op factuur',
    rates: 'Tarieven',
    startDate: 'Ingangsdatum',
    taxCategoryCode: 'UNECE code',
    vatNumber: 'BTW-nummer',
    vatNumberRequiredYN: 'BTW-nummer verplicht',
    vatPercentage: 'Tarief (%)',
    vatType: 'BTW-soort',
    vatTypeOption: 'Type'
  },
  wizard: {
    next: 'Volgende',
    prev: 'Vorige',
    skip: 'Overslaan',
    skipnexttwo: 'Overslaan (2)'
  },
  workshop: {
    code: 'Ateliernummer',
    excludeExpressOrderYN: 'Uitsluiten van spoedorders',
    excludeHandlockYN: 'Uitsluiten van handlock',
    excludeSamplesYN: ' Uitsluiten van showbanen',
    ignoreExcludedFabrics: 'Negeer uitgesloten stoffen',
    maximumProcessingHeight: 'Maximale verwerkingshoogte (cm)',
    metersMaxPerSeries: 'Meters per serie',
    panelsMaxPerSeries: 'Banen per serie',
    planningDisabled: 'Niet planbaar',
    romanBlindsMaxPerSeries: 'Vouwgordijnen per serie',
    stockLocationName: 'Naam voorraadlocatie'
  },
  yarn: {
    planningOrder: 'Planningsvolgorde'
  }
};
